import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SidebarModule } from 'primeng/sidebar';
import { MenuComponent } from './menu.component';

const PRIMENG_MODULES = [PanelMenuModule, SidebarModule];

@NgModule({
  declarations: [MenuComponent],
  imports: [CommonModule, ...PRIMENG_MODULES],
  exports: [MenuComponent],
})
export class MenuModule {}
